import React, { useEffect, useState } from 'react';
import { ChartComponent } from '../Chart/ChartComponent';
import { useSocket } from '../../hooks/useSocket';
import './TradingView.css';

export const TradingView: React.FC = () => {
  const [selectedSymbol, setSelectedSymbol] = useState('USDTIRT');
  const [selectedTimeframe, setSelectedTimeframe] = useState('1');
  
  const symbols = [
    { code: 'USDTIRT', name: 'Tether/IRT', short: 'USDT', color: '#26a17b' },
    { code: 'BTCIRT', name: 'Bitcoin/IRT', short: 'BTC', color: '#f7931a' },
    { code: 'ETHIRT', name: 'Ethereum/IRT', short: 'ETH', color: '#627eea' },
    { code: 'LTCIRT', name: 'Litecoin/IRT', short: 'LTC', color: '#bfbbbb' },
    { code: 'XRPIRT', name: 'Ripple/IRT', short: 'XRP', color: '#23292f' },
    { code: 'ADAIRT', name: 'Cardano/IRT', short: 'ADA', color: '#0033ad' }
  ];

  // Available timeframes
  const timeframes = [
    { value: '1', label: '1m' },
    { value: '5', label: '5m' },
    { value: '15', label: '15m' },
    { value: '30', label: '30m' },
    { value: '60', label: '1h' },
    { value: '240', label: '4h' },
    { value: 'D', label: '1d' }
  ];

  const { isConnected, onError } = useSocket();

  // Handle errors
  useEffect(() => {
    const handleError = (error: string) => {
      console.error('Socket error:', error);
    };

    onError(handleError);

    return () => {
      // Cleanup will be handled by useSocket hook
    };
  }, [onError]);

  // No need for symbol change handler since we only have BTCIRT

  return (
    <div className="trading-view">
      <div className="trading-header">
        <h1 className="heading-1">TVBox Chart Dashboard</h1>
        <div className="connection-status">
          <span className={`status-indicator status-text ${isConnected ? 'connected' : 'disconnected'}`}>
            {isConnected ? 'Connected' : 'Disconnected'}
          </span>
        </div>
      </div>

      <div className="trading-content">
        <div className="symbol-selector">
          <h3 className="heading-3">Crypto Charts</h3>
          <div className="symbol-display">
            {symbols.map((symbol) => (
              <div 
                key={symbol.code}
                className={`symbol-card ${selectedSymbol === symbol.code ? 'selected' : ''}`}
                onClick={() => setSelectedSymbol(symbol.code)}
                style={{ cursor: 'pointer' }}
              >
                <div className="symbol-avatar" style={{ backgroundColor: symbol.color }}>
                  <span className="avatar-text">{symbol.short}</span>
                </div>
                <div className="symbol-info">
                  <h4 className="heading-4">{symbol.name}</h4>
                  <span className="symbol-code trading-symbol">{symbol.code}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="chart-section">
          <div className="chart-title-section">
            <h3 className="heading-3">{selectedSymbol} Candlestick Chart</h3>
            <div className="timeframe-buttons">
              {timeframes.map((tf) => (
                <button
                  key={tf.value}
                  className={`timeframe-btn ${selectedTimeframe === tf.value ? 'active' : ''}`}
                  onClick={() => setSelectedTimeframe(tf.value)}
                >
                  {tf.label}
                </button>
              ))}
            </div>
          </div>
          
          <ChartComponent 
            symbol={selectedSymbol} 
            height={600}
            selectedTimeframe={selectedTimeframe}
          />
        </div>
      </div>
    </div>
  );
};
